import { useState } from "react"
import Icon from "../../components/Icon"
import RegisterUtBillsCompanyModal from "./RegisterUtBillsCompanyModal"

const ENTITY_TYPES = [
  { icon: "person", label: "Individual" },
  { icon: "shop", label: "Business (SME)" },
  { icon: "building", label: "Company" },
]

// Shown on the Billing/Invoicing tab until the user has a billing company. The
// button opens the same registration modal as the dashboard Register menu.
function BillingRegisterPrompt({ registeredUserName = "", onRegistered }) {
  const [registering, setRegistering] = useState(false)

  return (
    <section className="rounded-2xl border border-dashed border-teal-300 bg-gradient-to-br from-teal-50 to-emerald-50 p-8 text-center">
      <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-teal-600 text-white shadow-lg">
        <Icon name="shop" size="1.6rem" />
      </div>
      <h3 className="mt-4 text-base font-black text-slate-900">Start invoicing your clients.</h3>
      <p className="mx-auto mt-1 max-w-sm text-sm text-slate-600">
        Register to bill your customers for goods and services.
      </p>

      <ul className="mt-4 flex flex-wrap justify-center gap-2">
        {ENTITY_TYPES.map((type) => (
          <li
            key={type.label}
            className="inline-flex items-center gap-1.5 rounded-xl border border-teal-200 bg-white/70 px-3 py-1.5 text-xs font-semibold text-teal-800"
          >
            <Icon name={type.icon} size="0.85rem" />
            {type.label}
          </li>
        ))}
      </ul>

      <button
        type="button"
        onClick={() => setRegistering(true)}
        className="mt-5 w-full max-w-xs rounded-xl bg-teal-600 py-2.5 text-sm font-bold text-white transition-colors hover:bg-teal-700"
      >
        Click below to register
      </button>

      {registering && (
        <RegisterUtBillsCompanyModal
          registeredUserName={registeredUserName}
          onRegistered={onRegistered}
          onClose={() => setRegistering(false)}
        />
      )}
    </section>
  )
}

export default BillingRegisterPrompt
